import { errorToastMessage, successToastMessage } from "utils/errorToast";
import { LOADER_STATUS, EMAIL_TABLE_DATA, GSTINS, SELECTED_GSTIN, ACTIVE_TAB } from "./constants";
import { getLocalStorage } from "components/Helper/Helper.js";
import { Config } from "../../../Config.js";
import axios from "axios";

export const loader = (status) => {
  return {
    type: LOADER_STATUS,
    loaderStatus: status,
  };
};

export function setEmailTableData(data) {
  return {
    type: EMAIL_TABLE_DATA,
    emailTableData: data,
  };
}

export function setGstins(data) {
  return {
    type: GSTINS,
    gstins: data,
  };
}

export function setSelectedGstin(data) {
  return {
    type: SELECTED_GSTIN,
    selectedGstin: data,
  };
}

export function setActiveTab(data) {
  return {
    type: ACTIVE_TAB,
    activeTab: data,
  };
}

export const getGstinListConfig = () => {
  return async (dispatch) => {
    dispatch(loader(true));

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}gst/get_profile`,
        headers: {
          token: getLocalStorage("loginDetails"),
        },
      });

      console.log("response ", response);

      if (response.data.error === 0) {
        const gstinArray =
          response.data?.profileInfo?.map((profile) => profile.gstin) || [];
        const uniqueGstinArray = [...new Set(gstinArray)].sort((a, b) =>
          a > b ? 1 : -1
        );
        dispatch(setGstins(uniqueGstinArray));
        console.log("uniqueGstinArray ", uniqueGstinArray);
      }

      return true;
    } catch (error) {
      console.log("Error in getProfile:", error);
      errorToastMessage("Failed to fetch profile data");
      return false;
    } finally {
      dispatch(loader(false));
    }
  };
};

export const getEmailMasterDataByGstin = (gstin) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");

    try {
      const response = await axios({
        method: "get",
        url: `${Config.url}notices/email-master/gstin/${gstin}`,
        headers: {
          "Content-Type": "application/json",
          token,
        },
        timeout: 60000,
      });

      if (response.data.status === "success" && response.data.statusCode === 200) {
        console.log("Email Master Data by GSTIN:", response.data.data);
         dispatch(setEmailTableData(response.data.data || []));
        return { success: true, data: response.data.data };
      } else {
        console.log("API Error:", response.data);
        errorToastMessage(response.data.message || "Failed to fetch email configurations for GSTIN");
        return { success: false, data: [] };
      }
    } catch (error) {
      console.log("Error fetching email master data by GSTIN:", error);
      errorToastMessage("Error while fetching email configurations for GSTIN");
      return { success: false, data: [] };
    } finally {
      dispatch(loader(false));
    }
  };
};
export const getEmailMasterData = (gstin) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");

    try {
      const response = await axios({
        method: "get",
        url: `${Config.url}notices/email-master/gstin/${gstin}`,
        headers: {
          "Content-Type": "application/json",
          token,
        },
        timeout: 60000,
      });

      if (response.data.status === "success" && response.data.statusCode === 200) {
        console.log("Email Master Data by GSTIN:", response.data.data);
        //  dispatch(setEmailTableData(response.data.data || []));
        return { success: true, data: response.data.data };
      } else {
        console.log("API Error:", response.data);
        errorToastMessage(response.data.message || "Failed to fetch email configurations for GSTIN");
        return { success: false, data: [] };
      }
    } catch (error) {
      console.log("Error fetching email master data by GSTIN:", error);
      errorToastMessage("Error while fetching email configurations for GSTIN");
      return { success: false, data: [] };
    } finally {
      dispatch(loader(false));
    }
  };
};
export const getEmailConfigurations = (gstin = null) => {
  console.log('Fetching email configurations for GSTIN:', gstin)
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");

    try {
      let url = `${Config.url}notices/email-config`;
      
      // Add gstin as query parameter if provided
      if (gstin && gstin.trim() !== '') {
        url += `?gstin=${encodeURIComponent(gstin.trim())}`;
      }

      const response = await axios({
        method: "get",
        url: url,
        headers: {
          "Content-Type": "application/json",
          token,
        },
        timeout: 60000,
      });

      if (response.data.status === "success" && response.data.statusCode === 200) {
        console.log("Email Configurations:", response.data.data);
        dispatch(setEmailTableData(response.data.data || []));
        return { success: true, data: response.data.data };
      } else {
        console.log("API Error:", response.data);
        errorToastMessage(response.data.message || "Failed to fetch email configurations");
        return { success: false, data: [] };
      }
    } catch (error) {
      console.log("Error fetching email configurations:", error);
      errorToastMessage("Error while fetching email configurations");
      dispatch(setEmailTableData([]));
      return { success: false, data: [] };
    } finally {
      dispatch(loader(false));
    }
  };
};

export const deleteEmailConfiguration = (gstin) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");

    try {
      const response = await axios({
        method: "delete",
        url: `${Config.url}notices/email-config/${gstin}`,
        headers: {
          "Content-Type": "application/json",
          token,
        },
        timeout: 60000,
      });

      if (response.data.status === "success" && response.data.statusCode === 200) {
        console.log("Email Configuration Deleted:", response.data.data);
        successToastMessage(response.data.message || "Email configurations deleted successfully");
        return { success: true, data: response.data.data };
      } else {
        console.log("API Error:", response.data);
        errorToastMessage(response.data.message || "Failed to delete email configurations");
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      console.log("Error deleting email configurations:", error);
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        if (errorData.statusCode === 404) {
          errorToastMessage(errorData.message || "No email configurations found for this GSTIN");
        } else {
          errorToastMessage(errorData.message || "Error while deleting email configurations");
        }
        return { success: false, message: errorData.message };
      } else {
        errorToastMessage("Network error while deleting email configurations");
        return { success: false, message: "Network error" };
      }
    } finally {
      dispatch(loader(false));
    }
  };
};

export const createEmailConfigurations = (configData) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");

    try {
      const response = await axios({
        method: "post",
        url: `${Config.url}notices/email-config`,
        headers: {
          "Content-Type": "application/json",
          token,
        },
        data: configData,
        timeout: 60000,
      });

      if (response.data.status === "success" && response.data.statusCode === 201) {
        console.log("Email Configurations Created:", response.data.data);
        successToastMessage(response.data.message || "Email configurations created successfully");
        return { success: true, data: response.data.data };
      } else {
        console.log("API Error:", response.data);
        errorToastMessage(response.data.message || "Failed to create email configurations");
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      console.log("Error creating email configurations:", error);
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        if (errorData.statusCode === 409) {
          errorToastMessage(errorData.message || "Duplicate email configuration exists");
        } else if (errorData.statusCode === 400) {
          errorToastMessage(errorData.message || "Invalid input data");
        } else {
          errorToastMessage(errorData.message || "Error while creating email configurations");
        }
        return { success: false, message: errorData.message };
      } else {
        errorToastMessage("Network error while creating email configurations");
        return { success: false, message: "Network error" };
      }
    } finally {
      dispatch(loader(false));
    }
  };
};

export const updateEmailConfigurations = (configData) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");

    try {
      const response = await axios({
        method: "put",
        url: `${Config.url}notices/email-config`,
        headers: {
          "Content-Type": "application/json",
          token,
        },
        data: configData,
        timeout: 60000,
      });

      if (response.data.status === "success" && response.data.statusCode === 200) {
        console.log("Email Configurations Updated:", response.data.data);
        successToastMessage(response.data.message || "Email configurations updated successfully");
        return { success: true, data: response.data.data };
      } else {
        console.log("API Error:", response.data);
        errorToastMessage(response.data.message || "Failed to update email configurations");
        return { success: false, message: response.data.message };
      }
    } catch (error) {
      console.log("Error updating email configurations:", error);
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        if (errorData.statusCode === 404) {
          errorToastMessage(errorData.message || "Email configuration not found");
        } else if (errorData.statusCode === 400) {
          errorToastMessage(errorData.message || "Invalid input data");
        } else {
          errorToastMessage(errorData.message || "Error while updating email configurations");
        }
        return { success: false, message: errorData.message };
      } else {
        errorToastMessage("Network error while updating email configurations");
        return { success: false, message: "Network error" };
      }
    } finally {
      dispatch(loader(false));
    }
  };
};

// API function to send notice emails with documents
export const sendNoticeEmailWithDocuments = ({ gstin, email, refId }) => {
  return async (dispatch) => {
    dispatch(loader(true));
    const token = getLocalStorage("loginDetails");

    try {
      // Validate required parameters
      if (!gstin || !/^[A-Z0-9]{15}$/.test(gstin)) {
        errorToastMessage("Valid GSTIN is required (15 alphanumeric characters)");
        return {
          status: "error",
          statusCode: 400,
          message: "Valid GSTIN is required (15 alphanumeric characters)"
        };
      }

      if (!Array.isArray(email) || email.length === 0) {
        errorToastMessage("Email array is required and must contain at least one email address");
        return {
          status: "error",
          statusCode: 400,
          message: "Email array is required and must contain at least one email address"
        };
      }

      // Validate email addresses
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      for (const emailAddr of email) {
        if (!emailRegex.test(emailAddr)) {
          errorToastMessage(`Invalid email address: ${emailAddr}`);
          return {
            status: "error",
            statusCode: 400,
            message: `Invalid email address: ${emailAddr}`
          };
        }
      }

      if (!Array.isArray(refId) || refId.length === 0) {
        errorToastMessage("RefId array is required and must contain at least one reference ID");
        return {
          status: "error",
          statusCode: 400,
          message: "RefId array is required and must contain at least one reference ID"
        };
      }

      console.log(`[Notices Service] Email request initiated for GSTIN: ${gstin}, emails: ${email.length}, refIds: ${refId.length}`);

      const response = await axios({
        method: "post",
        url: `${Config.url}notices/email/send`,
        headers: {
          "Content-Type": "application/json",
          token,
        },
        data: {
          gstin,
          email,
          refId
        },
        timeout: 60000,
      });

      if (response.data.status === "success" && response.data.statusCode === 200) {
        console.log("Email request initiated successfully:", response.data.data);
        successToastMessage(response.data.message || "Request initiated. You will receive an email shortly.");
        return {
          status: "success",
          statusCode: 200,
          message: "Request initiated. You will receive an email shortly.",
          data: {
            gstin,
            totalEmails: email.length,
            documentCount: refId.length,
            status: "processing"
          }
        };
      } else {
        console.log("API Error:", response.data);
        errorToastMessage(response.data.message || "Failed to initiate email send");
        return { status: "error", message: response.data.message };
      }
    } catch (error) {
      console.error("[Notices Service] Error in sendNoticeEmailWithDocuments:", error);
      if (error.response && error.response.data) {
        const errorData = error.response.data;
        errorToastMessage(errorData.message || "Error while initiating email send");
        return { status: "error", message: errorData.message };
      } else {
        errorToastMessage("Network error while initiating email send");
        return { status: "error", message: "Network error" };
      }
    } finally {
      dispatch(loader(false));
    }
  };
};